<div class="Mat-Daterange" #dateRange>
  <div class="Mat-Daterange-Output" (click)="outputClick()">
    <one-icon name="calendar-clear-outline"></one-icon>
    <div class="Mat-Daterange-Label">{{ 'date_range.' + label | transloco }}</div>
  </div>
</div>